(function () {
  'use strict';

  var LENS = 130;
  var ZOOM = 3;
  var PANEL = 440;
  var panel, lens;

  var style = [
    '.lc-zl{position:fixed;border:2px solid rgba(255,255,255,0.9);background:rgba(255,255,255,0.12);pointer-events:none;z-index:9998;display:none;box-shadow:0 0 0 1px rgba(0,0,0,0.25),inset 0 0 8px rgba(255,255,255,0.08);border-radius:3px;}',
    '.lc-zp{position:fixed;border:1px solid #ddd;background:#fff no-repeat;box-shadow:0 12px 48px rgba(0,0,0,0.22),0 2px 8px rgba(0,0,0,0.1);border-radius:6px;z-index:9999;pointer-events:none;display:none;overflow:hidden;}',
    '.lc-zp::after{content:"";position:absolute;inset:0;border-radius:6px;box-shadow:inset 0 0 0 1px rgba(0,0,0,0.08);}',
    'media-gallery .m-product-media img{cursor:crosshair!important;}',
    '@media(max-width:1024px){.lc-zl,.lc-zp{display:none!important;}}'
  ].join('');

  function hiRes(src) {
    var clean = src.replace(/[?&]width=\d+/g, '').replace(/&&/g, '&').replace(/\?&/, '?').replace(/[?&]$/, '');
    return clean + (clean.includes('?') ? '&width=3000' : '?width=3000');
  }

  function setup() {
    var s = document.createElement('style');
    s.textContent = style;
    document.head.appendChild(s);

    panel = document.createElement('div');
    panel.className = 'lc-zp';
    document.body.appendChild(panel);

    lens = document.createElement('div');
    lens.className = 'lc-zl';
    lens.style.width = LENS + 'px';
    lens.style.height = LENS + 'px';
    document.body.appendChild(lens);
  }

  function attach() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    gallery.addEventListener('mousemove', onMove);
    gallery.addEventListener('mouseleave', hide);
    gallery.addEventListener('mediaChanged', hide);
  }

  function onMove(e) {
    var mediaEl = e.target.closest('.m-product-media');
    var img = mediaEl && mediaEl.querySelector('img');
    if (!mediaEl || !img) { hide(); return; }

    var rect = mediaEl.getBoundingClientRect();
    var cx = e.clientX - rect.left;
    var cy = e.clientY - rect.top;
    if (cx < 0 || cy < 0 || cx > rect.width || cy > rect.height) { hide(); return; }

    var half = LENS / 2;
    var lx = Math.max(half, Math.min(rect.width - half, cx));
    var ly = Math.max(half, Math.min(rect.height - half, cy));

    lens.style.left = (rect.left + lx - half) + 'px';
    lens.style.top  = (rect.top  + ly - half) + 'px';
    lens.style.display = 'block';

    var bgW = rect.width  * ZOOM;
    var bgH = rect.height * ZOOM;
    var bgX = PANEL / 2 - lx * ZOOM;
    var bgY = PANEL / 2 - ly * ZOOM;

    var src = img.currentSrc || img.src;
    panel.style.backgroundImage    = 'url("' + hiRes(src) + '")';
    panel.style.backgroundSize     = bgW + 'px ' + bgH + 'px';
    panel.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    panel.style.width  = PANEL + 'px';
    panel.style.height = PANEL + 'px';

    var vpW = window.innerWidth;
    var vpH = window.innerHeight;
    var gap = 14;
    var px = (rect.right + gap + PANEL <= vpW)
      ? rect.right + gap
      : (rect.left - gap - PANEL >= 0)
        ? rect.left - gap - PANEL
        : Math.max(8, vpW - PANEL - 8);

    var py = Math.max(8, Math.min(e.clientY - PANEL / 2, vpH - PANEL - 8));

    panel.style.left    = px + 'px';
    panel.style.top     = py + 'px';
    panel.style.display = 'block';
  }

  function hide() {
    if (panel) panel.style.display = 'none';
    if (lens)  lens.style.display  = 'none';
  }

  function init() {
    setup();
    if (document.querySelector('media-gallery')) {
      attach();
    } else {
      var obs = new MutationObserver(function () {
        if (document.querySelector('media-gallery')) { obs.disconnect(); attach(); }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();